var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("detail-form", {
    attrs: {
      history: true,
      id: _vm.id,
      uid: _vm.uid
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };